import { render } from "./Section4.vue?vue&type=template&id=21ef8efc"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"

import "./Section4.vue?vue&type=style&index=0&id=21ef8efc&lang=scss"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__